<!--Basics of this component
1) This will be a sub compnente of the Project Detail component
2) Sets up data an array of existing project aliases and the project ID
3) Calls Create and EditDelete component as required
3) Posts new name to server 
4) Updates state for this project aliases
5) Handels errors from server (duplicate name or 500 most likley)
-->

<template>
  <div>
    <b-modal
      id="alias-crud"
      title="Edit Project Aliases"
      @ok="postApi(id)"
      @hidden="navBack()"
      :busy="false"
      return-focus="body"
    >
<!-- <div v-if="dataLoaded == false" class="text-center">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <p>Loading</p>
      </div> -->

      <div v-if="error != null" class="text-center">
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        <div v-html="error"></div>
      </div>

      <router-view></router-view>
      <p style="strong">People use these names to sign into this project</p>

      <b-list-group flush>
        <!-- This is the header item for the modal and the place to click to add a new alias -->
        <b-list-group-item class="bg-dark text-light" style="font-weight: bold "
          >Project Aliases
          <font-awesome-icon
            icon="plus"
            size="lg"
            style="float:right"
            @click="navCreateAlias()"
          ></font-awesome-icon>
        </b-list-group-item>
      </b-list-group>

      <b-list-group flush v-if="aliases != null">
        <b-list-group-item v-for="(item, key) in aliases" :key="key">
          {{ item.aliasName }} with {{item.attendanceCount}} attendances
          <router-link :to="{ name: 'aliasUpdate', params:{aliasId:key}}">
            <font-awesome-icon
              icon="edit"
              size="lg"
              style="float:right"
            ></font-awesome-icon>
          </router-link>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      test: "some test"
    };
  },
  computed:{
    project(){
      return this.$store.getters.project
    },
    aliases(){
      if(this.$store.getters.project != null){
        return this.project.aliases
      }
      return null
    },
    error(){
      return this.$store.getters.axiosError
    },
  },
  mounted() {
    this.$bvModal.show("alias-crud");
  },

  methods: {
    editSelectedAlias() {
      return;
    },
    
    navBack() {
      // If error clear them before going back
      if(this.error != null){
        this.$store.dispatch('axiosError', null)
      }
      this.$router.go(-1);
    },
    navCreateAlias() {
      this.$router.push({ name: "aliasCreate" });
    }
  }
};
</script>

<style scoped></style>
